import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { baseUrl } from "src/environments/environment";

export type ContactSettings = {
  country: "malaysia" | "singapore";
  whatsappLink: string;
  whatsappNumber: string;
  phoneNumber: string;
  email: string;
};

const defaultContactSettings: ContactSettings = {
  country: "malaysia",
  whatsappLink: "https://wa.link/d0to5k",
  whatsappNumber: "+6011-1100 8882",
  phoneNumber: "+603-8681 7351",
  email: "support@altomate.io"
};

@Injectable({ providedIn: "root" })
export class ContactSettingsService {
  private cached: ContactSettings | null = null;
  private loading: Promise<ContactSettings> | null = null;

  constructor(private http: HttpClient) {}

  async getContactSettings(options?: { country?: "malaysia" | "singapore"; forceRefresh?: boolean }): Promise<ContactSettings> {
    const country = options?.country || "malaysia";
    const forceRefresh = Boolean(options?.forceRefresh);

    if (!forceRefresh && this.cached && this.cached.country === country) {
      return this.cached;
    }

    if (!forceRefresh && this.loading) {
      return this.loading;
    }

    this.loading = (async () => {
      try {
        const result = await firstValueFrom(
          this.http.get<ContactSettings>(`${baseUrl}/api/contact-settings?country=${encodeURIComponent(country)}`)
        );
        this.cached = result || defaultContactSettings;
        return this.cached;
      } catch {
        this.cached = defaultContactSettings;
        return this.cached;
      } finally {
        this.loading = null;
      }
    })();

    return this.loading;
  }
}
